import React, {useState} from 'react';
import {CheckIcon, ChevronDownIcon, ChevronUpDownIcon} from '@heroicons/react/16/solid'
import {Label, Listbox} from '@headlessui/react';
import { useNavigate } from 'react-router-dom';
import FooterComponent from "./FooterComponent";
import NavComponent from "./NavComponent";

/*
* Quitar el lugar cuando no hacen deporte
*
* */
const departamento =[
    { nombre: '' },
    { nombre: 'Administración' },
    { nombre: 'Almacén' },
    { nombre: 'Calidad' },
    { nombre: 'Comercial' },
    { nombre: 'Compensaciones' },
    { nombre: 'Compras' },
    { nombre: 'Control Interno' },
    { nombre: 'Control Vehicular' },
    { nombre: 'Desarrollo Organizacional' },
    { nombre: 'Dirección General' },
    { nombre: 'Finanzas' },
    { nombre: 'Juridico' },
    { nombre: 'Marketing' },
    { nombre: 'Operaciones PI' },
    { nombre: 'Operaciones PE' },
    { nombre: 'Planeación' },
    { nombre: 'Recursos Humanos' },
    { nombre: 'Servicios Generales' },
    { nombre: 'Sistemas' },
    { nombre: 'Taller de Herramientas' },
    { nombre: 'TI' }
]

const cdo =[
    { nombre : ''},
    { nombre : 'CDO Ganaderos'},
    { nombre : 'CDO Pantitlan'},
    { nombre : 'CDO Toluca'},
    { nombre : 'CDO Coacalco'},
    { nombre : 'CDO Querétaro'},
    { nombre : 'CDO Guadalajara'},
    { nombre : 'CDO Vallarta'},
    { nombre : 'CDO Celaya'},
    { nombre : 'CDO Aguascalientes'},
    { nombre : 'CDO Ladoga'},
    { nombre : 'CDO Monterrey'},
    { nombre : 'CDO Texcoco'},
    { nombre : 'CDO Puebla'},
    { nombre : 'Corporativo Santa Fe'}
]

const donde_deporte =[
    { nombre : ''},
    { nombre: 'No realizo deporte' },
    { nombre: 'Casa' },
    { nombre: 'Gimnasio' },
    { nombre: 'Parque' },
]

const dto = [
    { nombre : 'Ninguno (Personal Administrativo)'},
    { nombre : 'Colomos'},
    { nombre : 'Queretaro'},
    { nombre : 'San Juan Del Rio'},
    { nombre : 'Puerto Vallarta'},
    { nombre : 'Guadalajara'},
    { nombre : 'Aeropuerto'},
    { nombre : 'Las Aguilas'},
    { nombre : 'Neza'},
    { nombre : 'Huehuetoca'},
    { nombre : 'Los Reyes'},
    { nombre : 'Tlalnepantla'},
    { nombre : 'Tultitlán'},
    { nombre : 'Aguascalientes'},
    { nombre : 'Celaya'},
    { nombre : 'Angelopolis'},
    { nombre : 'Condesa'},
    { nombre : 'Pedregal'},
    { nombre : 'Santa Fe'},
    { nombre : 'Tlalpan'},
    { nombre : 'Metronot'},
    { nombre : 'Norpte'},
    { nombre : 'Surpte'},
    { nombre : 'Lerma'},
    { nombre : 'Valle De Bravo'},
    { nombre : 'Metepec'},
]

function RegistroComponent() {

    const [departamentoSelected, setDepartamentoSelected] = useState(departamento[0]);
    const [cdoSelected, setCdoSelected] = useState(cdo[0]);
    const [dtoSelected, setDtoSelected] = useState(dto[0]);
    const [dondeDeporteSelected, setDondedeporteSelected] = useState(donde_deporte[0]);
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [archivo, setArchivo] = useState<File | null>(null);
    const [rutaImagen, setRutaImagen] = useState('');

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
    ) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        const input = e.target as HTMLInputElement;
        if (input.files && input.files.length > 0) {
            setArchivo(input.files[0]);
        }
    };

    const [formData, setFormData] = useState({
        first_name:'',
        last_name:'',
        email:'',
        password:'',
        area_departamento:'',
        cdo:'',
        fec_nac:'',
        telefono:'',
        hace_deporte: true,
        deporte: '',
        puesto:'',
        peso:'',
        donde_deporte:'',
        dto:'',
        ruta_archivo:''
    });


    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        if (!formData.area_departamento || !formData.cdo || (formData.hace_deporte && !formData.deporte ) || !formData.donde_deporte ) {
            alert("Por favor llena todos los campos.");
            return;
        }

        /***********/
        if (!archivo) {
            alert("Por favor selecciona una imagen.");
            return;
        }

        const formDataImage = new FormData();
        formDataImage.append("imagen", archivo);

        console.log(formDataImage);

        try {
            const res = await fetch("https://apis.grupobrame.com/heroes/api/subir_imagen", {
                method: "POST",
                body: formDataImage,
            });

            const result = await res.json();
            if (result.success) {
                const imagenPath = result.path;
                setRutaImagen(imagenPath); // (opcional, por si necesitas mostrarlo en UI)
                formData.ruta_archivo = imagenPath;
            } else {
                alert("Error al subir la imagen: " + result.message);
            }
        } catch (error) {
            console.error("Error al subir:", error);
            alert("Error al subir la imagen");
        }
        /*************/



        console.log(rutaImagen);
        console.log(formData.ruta_archivo);
        console.log(formData);
        {/* https://apis.grupobrame.com/heroes/api/registro */}
        try {
            const response = await fetch("https://apis.grupobrame.com/heroes/api/registro", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    correo: formData.email,
                    contraseña: formData.password,
                    nombre: formData.first_name,
                    apellido: formData.last_name,
                    fecha_nacimiento: formData.fec_nac,
                    telefono: formData.telefono,
                    hace_deporte: formData.hace_deporte,
                    deporte: formData.deporte,
                    donde_deporte: formData.donde_deporte,
                    peso: parseFloat(formData.peso),
                    cdo: formData.cdo,
                    dto: formData.dto,
                    area: formData.area_departamento,
                    puesto: formData.puesto,
                    ruta_archivo: formData.ruta_archivo
                })
            });

            const result = await response.json();
            if (result.success) {
                alert("Registro guardado exitosamente");
                window.scrollTo(0, 0);
                navigate('/');
            } else {
                alert("Error: " + result.message);
            }
        } catch (err) {
            alert("Error al enviar: " + err);
        }
    };



    const handleCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.checked,
            deporte: e.target.checked ? formData.deporte : '' // limpia el campo si desactiva el checkbox
        });
    };

    return (
        <div>
            <NavComponent />
            <div className="my-10 sm:mx-auto sm:w-full sm:max-w-3xl text-left">
                <div className="bg-white px-6 py-12 shadow-sm sm:rounded-lg sm:px-12">
                    <form onSubmit={handleSubmit} className="space-y-6 mx-auto">
                        <div className="px-4 py-6 sm:p-8">
                            <h2 className="text-lg font-medium text-gray-900 mb-8">Información de registro</h2>

                            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="email" className="block text-sm/6 font-medium text-gray-900">
                                        Correo
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="email"
                                            name="email"
                                            type="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            placeholder="Ej: jose.perez@gmail.com"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="password" className="block text-sm/6 font-medium text-gray-900">
                                        Contraseña
                                    </label>
                                    <div className="mt-2 relative">
                                        <input
                                            id="password"
                                            name="password"
                                            type={showPassword ? 'text' : 'password'}
                                            autoComplete="password"
                                            value={formData.password}
                                            onChange={handleChange}
                                            required
                                            className="block w-full rounded-md bg-white px-3 py-1.5 pr-10 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                        <button
                                            type="button"
                                            onClick={() => setShowPassword(!showPassword)}
                                            className="absolute inset-y-0 right-2 flex items-center text-gray-500 hover:text-gray-700"
                                        >
                                            {showPassword ? (
                                                // Ojo abierto
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                                                     viewBox="0 0 24 24" stroke="orange">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                          d="M2.458 12C3.732 7.943 7.522 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.478 0-8.268-2.943-9.542-7z" />
                                                </svg>
                                            ) : (
                                                // Ojo tachado
                                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none"
                                                     viewBox="0 0 24 24" stroke="currentColor">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
                                                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.542-7a9.956 9.956 0 012.341-3.948m3.507-2.507A9.956 9.956 0 0112 5c4.478 0 8.268 2.943 9.542 7a9.967 9.967 0 01-4.205 5.568M15 12a3 3 0 00-4.243-2.828M3 3l18 18" />
                                                </svg>
                                            )}
                                        </button>
                                    </div>
                                </div>

                                <div className="sm:col-span-6 col-span-6">
                                    <label htmlFor=""
                                           className="block text-sm/6 font-medium text-gray-900">
                                        Foto de Perfil
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            type="file"
                                            accept="image/*"
                                            onChange={handleChange}
                                            className="file:mr-4 file:rounded-lg file:border-0 file:bg-orange-400 file:px-4 file:py-2 file:text-sm file:font-semibold file:text-white hover:file:bg-orange-500"
                                            required
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="mt-10 border-t border-gray-200 pt-10"></div>
                            <h2 className="text-lg font-medium text-gray-900 mb-8">Información personal</h2>
                            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="first_name" className="block text-sm/6 font-medium text-gray-900">
                                        Nombre
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="first_name"
                                            name="first_name"
                                            type="text"
                                            value={formData.first_name}
                                            onChange={handleChange}
                                            required
                                            placeholder="Ej: Jose Juan"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="last_name" className="block text-sm/6 font-medium text-gray-900">
                                        Apellidos
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="last_name"
                                            name="last_name"
                                            type="text"
                                            autoComplete="family-name"
                                            value={formData.last_name}
                                            onChange={handleChange}
                                            required
                                            placeholder="Ej: Perez García"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="fec_nac" className="block text-sm/6 font-medium text-gray-900">
                                        Fecha de Nacimiento
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="fec_nac"
                                            name="fec_nac"
                                            type="date"
                                            autoComplete="fec_nac"
                                            value={formData.fec_nac}
                                            onChange={handleChange}
                                            required
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="telefono" className="block text-sm/6 font-medium text-gray-900">
                                        Teléfono
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="telefono"
                                            name="telefono"
                                            type="tel"
                                            autoComplete="telefono"
                                            pattern="[0-9]{10}"
                                            value={formData.telefono}
                                            onChange={handleChange}
                                            required
                                            placeholder="Ej: 5520304050"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6 flex items-center">
                                    <div className="text-sm mr-4">
                                        <label htmlFor="hace_deporte" className="font-medium text-gray-900">
                                            ¿Realizas deporte?
                                        </label>
                                    </div>
                                    <div className="group grid size-4 grid-cols-1">
                                        <input
                                            id="hace_deporte"
                                            name="hace_deporte"
                                            type="checkbox"
                                            checked={formData.hace_deporte}
                                            onChange={handleCheck}
                                            className="col-start-1 row-start-1 appearance-none rounded-sm border border-gray-300 bg-white checked:border-orange-400 checked:bg-orange-400 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-400"
                                        />
                                        <svg
                                            fill="none"
                                            viewBox="0 0 14 14"
                                            className="pointer-events-none col-start-1 row-start-1 size-3.5 self-center justify-self-center stroke-white group-has-disabled:stroke-gray-950/25"
                                        >
                                            <path
                                                d="M3 8L6 11L11 3.5"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="opacity-0 group-has-checked:opacity-100"
                                            />
                                            <path
                                                d="M3 7H11"
                                                strokeWidth={2}
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                className="opacity-0 group-has-indeterminate:opacity-100"
                                            />
                                        </svg>
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="deporte" className="block text-sm/6 font-medium text-gray-900">
                                        Deporte
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="deporte"
                                            name="deporte"
                                            type="text"
                                            autoComplete="off"
                                            value={formData.deporte}
                                            onChange={handleChange}
                                            disabled={!formData.hace_deporte}
                                            placeholder="Ej: Fútbol, natación, gym"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6 disabled:bg-gray-100 disabled:text-gray-400"
                                        />
                                    </div>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <Listbox
                                        value={dondeDeporteSelected}
                                        onChange={(selected) => {
                                            setDondedeporteSelected(selected);
                                            setFormData((prev) => ({
                                                ...prev,
                                                donde_deporte: selected.nombre
                                            }));
                                        }}
                                    >
                                        <Label
                                            htmlFor="donde_deporte"
                                            className="block text-sm/6 font-medium text-gray-900"
                                        >
                                            ¿Dónde sueles hacer ejercicio?
                                        </Label>

                                        <div className="relative mt-2">
                                            <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6">
                                                <span className="col-start-1 row-start-1 truncate pr-6">
                                                  {dondeDeporteSelected.nombre || 'Selecciona una opción'}
                                                </span>
                                                <ChevronUpDownIcon
                                                    aria-hidden="true"
                                                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                                            </Listbox.Button>

                                            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                                {donde_deporte.map((donde) => (
                                                    <Listbox.Option

                                                        value={donde}
                                                        className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                    >
                                                <span className="block truncate font-normal group-data-selected:font-semibold">
                                                  {donde.nombre}
                                                </span>
                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
                                                  <CheckIcon aria-hidden="true" className="size-5" />
                                                </span>
                                                    </Listbox.Option>
                                                ))}
                                            </Listbox.Options>
                                        </div>
                                    </Listbox>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="peso" className="block text-sm/6 font-medium text-gray-900">
                                        Peso
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="peso"
                                            name="peso"
                                            type="number"
                                            value={formData.peso}
                                            onChange={handleChange}
                                            placeholder="Ej: 83.5"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6 disabled:bg-gray-100 disabled:text-gray-400"
                                        />
                                    </div>
                                </div>





                            </div>


                            <div className="mt-10 border-t border-gray-200 pt-10"></div>
                            <h2 className="text-lg font-medium text-gray-900 mb-8">Información Laboral</h2>
                            <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">

                                <div className="sm:col-span-3 col-span-6">
                                    <Listbox
                                        value={cdoSelected}
                                        onChange={(selected) => {
                                            setCdoSelected(selected);
                                            setFormData((prev) => ({
                                                ...prev,
                                                cdo: selected.nombre
                                            }));
                                        }}
                                    >
                                        <Label
                                            htmlFor="area_departamento"
                                            className="block text-sm/6 font-medium text-gray-900"
                                        >
                                            CDO al que perteneces
                                        </Label>

                                        <div className="relative mt-2">
                                            <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6">
                                                <span className="col-start-1 row-start-1 truncate pr-6">
                                                  {cdoSelected.nombre || 'Selecciona un CDO'}
                                                </span>
                                                <ChevronUpDownIcon
                                                    aria-hidden="true"
                                                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                                            </Listbox.Button>

                                            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                                {cdo.map((cd) => (
                                                    <Listbox.Option

                                                        value={cd}
                                                        className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                    >
                                                <span className="block truncate font-normal group-data-selected:font-semibold">
                                                  {cd.nombre}
                                                </span>
                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
                                                  <CheckIcon aria-hidden="true" className="size-5" />
                                                </span>
                                                    </Listbox.Option>
                                                ))}
                                            </Listbox.Options>
                                        </div>
                                    </Listbox>
                                </div>

                                <div className="sm:col-span-3 col-span-6">
                                    <Listbox
                                        value={dtoSelected}
                                        onChange={(selected) => {
                                            setDtoSelected(selected);
                                            setFormData((prev) => ({
                                                ...prev,
                                                dto: selected.nombre
                                            }));
                                        }}
                                    >
                                        <Label
                                            htmlFor="dto"
                                            className="block text-sm/6 font-medium text-gray-900"
                                        >
                                            Distrito al que perteneces
                                        </Label>

                                        <div className="relative mt-2">
                                            <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6">
                                                <span className="col-start-1 row-start-1 truncate pr-6">
                                                  {dtoSelected.nombre || 'Selecciona un Distrito'}
                                                </span>
                                                <ChevronUpDownIcon
                                                    aria-hidden="true"
                                                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                                            </Listbox.Button>

                                            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                                {dto.map((dt) => (
                                                    <Listbox.Option

                                                        value={dt}
                                                        className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                    >
                                                <span className="block truncate font-normal group-data-selected:font-semibold">
                                                  {dt.nombre}
                                                </span>
                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
                                                  <CheckIcon aria-hidden="true" className="size-5" />
                                                </span>
                                                    </Listbox.Option>
                                                ))}
                                            </Listbox.Options>
                                        </div>
                                    </Listbox>
                                </div>


                                <div className="sm:col-span-3 col-span-6">
                                    <Listbox
                                        value={departamentoSelected}
                                        onChange={(selected) => {
                                            setDepartamentoSelected(selected);
                                            setFormData((prev) => ({
                                                ...prev,
                                                area_departamento: selected.nombre
                                            }));
                                        }}
                                    >
                                        <Label
                                            htmlFor="area_departamento"
                                            className="block text-sm/6 font-medium text-gray-900"
                                        >
                                            Área / Departamento
                                        </Label>

                                        <div className="relative mt-2">
                                            <Listbox.Button className="grid w-full cursor-default grid-cols-1 rounded-md bg-white py-1.5 pr-2 pl-3 text-left text-gray-900 outline-1 -outline-offset-1 outline-gray-300 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-600 sm:text-sm/6">
                                                <span className="col-start-1 row-start-1 truncate pr-6">
                                                  {departamentoSelected.nombre || 'Selecciona un área'}
                                                </span>
                                                <ChevronUpDownIcon
                                                    aria-hidden="true"
                                                    className="col-start-1 row-start-1 size-5 self-center justify-self-end text-gray-500 sm:size-4"
                                                />
                                            </Listbox.Button>

                                            <Listbox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black/5 focus:outline-hidden sm:text-sm">
                                                {departamento.map((depa) => (
                                                    <Listbox.Option

                                                        value={depa}
                                                        className="group relative cursor-default py-2 pr-9 pl-3 text-gray-900 select-none data-focus:bg-orange-400 data-focus:text-white"
                                                    >
                                                    <span className="block truncate font-normal group-data-selected:font-semibold">
                                                      {depa.nombre}
                                                    </span>
                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-not-data-selected:hidden group-data-focus:text-white">
                                                      <CheckIcon aria-hidden="true" className="size-5" />
                                                    </span>
                                                    </Listbox.Option>
                                                ))}
                                            </Listbox.Options>
                                        </div>
                                    </Listbox>
                                </div>


                                <div className="sm:col-span-3 col-span-6">
                                    <label htmlFor="puesto" className="block text-sm/6 font-medium text-gray-900">
                                        Puesto
                                    </label>
                                    <div className="mt-2">
                                        <input
                                            id="puesto"
                                            name="puesto"
                                            type="text"
                                            value={formData.puesto}
                                            onChange={handleChange}
                                            required
                                            placeholder="Supervisor de Planta Interna"
                                            className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-orange-500 sm:text-sm/6"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white px-3.75 sm:rounded-lg sm:px-8">
                            <button
                                type="submit"
                                className="flex mx-auto w-full  justify-center rounded-md bg-orange-400 px-3 py-1.5 text-sm/6 font-semibold text-white shadow-xs hover:bg-orange-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                            >
                                Enviar
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <FooterComponent />
        </div>

    );
}

export default RegistroComponent;